import { resolveApiUrl } from '@lib/utils';

import { customHeaders } from './headers';

/**
 * A wrapper around the Fetch API to simplify HTTP requests.
 *
 * @param {string} url - The endpoint URL.
 * @param {RequestInit} options - Request options.
 * @returns {Promise<Response>} the fetch response.
 */
export async function fetchWrapper(
  url: string,
  { headers, ...props }: RequestInit,
): Promise<Response> {
  const resolveURL = resolveApiUrl(url);
  return await fetch(resolveURL, { ...props, headers: customHeaders(headers) });
}
